// Web replacement for @react-native-firebase/analytics. Uses Google Analytics for Firebase
// when a measurement ID is configured, otherwise does nothing.
import {
  getAnalytics,
  isSupported,
  logEvent,
  setUserId,
  setUserProperties,
  type Analytics,
} from 'firebase/analytics';
import { firebaseApp } from '../firebase';

let instance: Promise<Analytics | null> | null = null;

function resolve(): Promise<Analytics | null> {
  if (!instance) {
    instance = import.meta.env.FIREBASE_WEB_MEASUREMENT_ID
      ? isSupported().then(ok => (ok ? getAnalytics(firebaseApp) : null)).catch(() => null)
      : Promise.resolve(null);
  }
  return instance;
}

const module = {
  async logEvent(name: string, params?: Record<string, unknown>) {
    const a = await resolve();
    if (a) logEvent(a, name, params);
  },
  async logScreenView(params: { screen_name?: string; screen_class?: string }) {
    const a = await resolve();
    if (a) logEvent(a, 'screen_view' as string, params);
  },
  async logLogin(params: { method: string }) {
    const a = await resolve();
    if (a) logEvent(a, 'login', params);
  },
  async logAppOpen() {
    const a = await resolve();
    if (a) logEvent(a, 'app_open');
  },
  async setUserId(id: string | null) {
    const a = await resolve();
    if (a) setUserId(a, id);
  },
  async setUserProperty(name: string, value: string | null) {
    const a = await resolve();
    if (a) setUserProperties(a, { [name]: value });
  },
};

export default function analytics() {
  return module;
}
